import { useEffect, useState } from "react";
import { api, errorMessage, formatDate } from "./assetsShared";
import "./Assets.css";

export default function HardwareEmployee() {
  const [hardware, setHardware] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    api
      .get("/hardware/my") // assigned only (backend filtered)
      .then((res) => setHardware(res.data || []))
      .catch((requestError) =>
        setError(errorMessage(requestError, "Unable to load your hardware."))
      )
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="as-page as-page-soft">
      <div className="as-header">
        <h2>My Assigned Hardware</h2>
      </div>

      {error && <div className="as-alert">{error}</div>}

      {loading && <div className="as-empty">Loading hardware...</div>}

      {!loading && hardware.length === 0 && !error && (
        <div className="as-empty">No hardware assigned</div>
      )}

      {!loading && hardware.length > 0 && (
        <div className="as-employee-grid">
          {hardware.map((h) => (
            <div key={h._id} className="as-employee-card">
              <div className="as-employee-card-head">
                <div className="as-employee-type">{h.type}</div>
                <div className="as-employee-brand">{h.productBrand}</div>
              </div>

              <div className="as-employee-card-body">
                <InfoRow label="PC Name" value={h.pcName} />
                <InfoRow label="IP Address" value={h.ipAddress} />
                <InfoRow label="Location" value={h.location} />
                <InfoRow label="Connection Type" value={h.connectionType} />
                <InfoRow
                  label="Assigned On"
                  value={formatDate(h.assignedAt || h.updatedAt)}
                />
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

function InfoRow({ label, value }) {
  return (
    <div className="as-info-row">
      <span>{label}</span>
      <strong>{value || "—"}</strong>
    </div>
  );
}